module.exports = "pegasus/assets/styleGroup2-google.png";